import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'

export interface CatchwordProps {
  children?: ReactNode
}

const StyledCatchword = styled.div`
  ${({
    theme: {
      spacing: { spacing4 },
      colors: { textBrand },
      typography: {
        subheads: {
          small1: { bundledCSS: small1SubheadingCSS },
        },
      },
      utils: { ellipsis },
    },
  }) => css`
    ${small1SubheadingCSS};
    color: ${textBrand};
    margin-bottom: ${spacing4};
    ${ellipsis('100%', 1)};
    display: block;
  `}
`

const Catchword: FunctionComponent<CatchwordProps> = ({ children }) => (
  <StyledCatchword>{children}</StyledCatchword>
)

export default Catchword
